exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mgzzl{padding-left:20px;padding-right:20px}._1zKt0{margin:0 auto;padding:0 0 40px;max-width:1080px}.W-7ly{font-size:95px}._1Sgvw,.W-7ly{font-weight:700;margin:0}._1Sgvw{font-size:85px}._2PBER{text-align:center}._2Pvfl{padding-left:0;list-style:none}.Tl13L{font-size:15px;color:#484848}a,a:hover{color:#008489}._3SKeO{margin-top:12px}._2qghI{margin-bottom:12px}._2MjRd{margin-bottom:48px}.Dsvk9{margin-top:48px}", ""]);

// exports
exports.locals = {
	"root": "mgzzl",
	"container": "_1zKt0",
	"textJumbo": "W-7ly",
	"textMedium": "_1Sgvw",
	"textCenter": "_2PBER",
	"listStyled": "_2Pvfl",
	"subTitle": "Tl13L",
	"spaceTop2": "_3SKeO",
	"space2": "_2qghI",
	"space6": "_2MjRd",
	"spaceTop6": "Dsvk9"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/warning/Warning.css
// module id = 2657
// module chunks = 15